import { Brand } from "./Brand";
import { WhatsAppIcon } from "./icons";
import { scrollToId } from "../lib/scroll";
import { SITE, waLink } from "../lib/site";

const NAV = [
  { id: "gallery", label: "Our Rugs" },
  { id: "how-it-works", label: "How It Works" },
  { id: "customise", label: "Customise" },
  { id: "faqs", label: "FAQs" },
];

export function Footer() {
  return (
    <footer className="bg-forest texture-weave-dark text-ivory" data-testid="footer">
      <div className="max-w-6xl mx-auto px-5 sm:px-6 py-14 sm:py-16">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <Brand dark />
            <p className="mt-3 font-serif italic text-brass-light">{SITE.tagline}</p>
            <p className="mt-4 text-sm leading-relaxed text-ivory/70 max-w-xs">
              An independent studio making one-of-one tufted rugs — from a little idea to something
              you can feel.
            </p>
          </div>

          <nav aria-label="Footer" className="text-sm">
            <p className="uppercase tracking-[0.2em] text-xs text-brass-light font-medium">Explore</p>
            <ul className="mt-4 space-y-2.5">
              {NAV.map((n) => (
                <li key={n.id}>
                  <button
                    onClick={() => scrollToId(n.id)}
                    className="text-ivory/80 hover:text-ivory transition-colors duration-200"
                    data-testid={`footer-nav-${n.id}`}
                  >
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <div className="text-sm">
            <p className="uppercase tracking-[0.2em] text-xs text-brass-light font-medium">Enquiries</p>
            <p className="mt-4 text-ivory/80 leading-relaxed">
              The studio talks to every customer directly on WhatsApp — share your idea and we'll
              take it from there.
            </p>
            <a
              href={waLink(SITE.waGenericMessage)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-button"
              className="mt-4 inline-flex items-center gap-2 rounded-full bg-ivory text-forest font-medium px-5 py-2.5 transition-all duration-200 hover:-translate-y-0.5 hover:bg-brass-soft"
            >
              <WhatsAppIcon />
              {SITE.whatsappDisplay}
            </a>
          </div>
        </div>

        <div className="mt-12 border-t border-ivory/15 pt-6 space-y-2 text-xs text-ivory/55">
          <p>
            Tuft and Tale is an independent studio. Fan-inspired designs shown on this site are
            original artwork made to order and are not affiliated with, endorsed by, or licensed by
            any rights holder.
          </p>
          <p>
            Materials, timelines, and care details are confirmed with you during your enquiry.
            © {new Date().getFullYear()} Tuft and Tale. Handcrafted, made to order.
          </p>
        </div>
      </div>
    </footer>
  );
}
